//general reducer functions
export function UpdateObjectInArray(array, action) {
    // console.log("UpdateObjectInArrayxx", array, action);
    if (array === undefined) return null;
    if (!array) return null;
    return array.map((item, index) => {
        if (action.index !== null && action.index !== index) {
            return item;
        }
        if (action.id !== null && (item.id !== action.id || item.Ref !== action.id)) {
            // This isn't the item we care about - keep it as-is
            return item;
        }

        if (action.section) {
            if (action.subsection) {
                if (action.parameter) {
                    return {
                        ...item,
                        [action.section]: {
                            ...item[action.section],
                            [action.subsection]: {
                                ...item[action.section][action.subsection],
                                [action.parameter]: action.value,
                            },
                        },
                    };
                } else {
                    return {
                        ...item,
                        [action.section]: {
                            ...item[action.section],
                            [action.subsection]: action.value,
                        },
                    };
                }
            } else if (action.parameter) {
                return {
                    ...item,
                    [action.section]: {
                        ...item[action.section],
                        [action.parameter]: action.value,
                    },
                };
            } else {
                // console.log({
                //   ...item,
                //   [action.section]: action.value
                // });
                return {
                    ...item,
                    [action.section]: action.value,
                };
            }
        } else if (action.parameter) {
            // Otherwise, this is the one we want - return an updated value
            return {
                ...item,
                [action.parameter]: action.value,
            };
        } else {
            return {
                ...item,
                ...action.value,
            };
        }
    });
}
